export default "__VITE_ASSET__u_kbvSO0__"